import { useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import {
  type TitleJournalMutateOptions,
  withTitleJournalInvalidation,
} from "./invalidate-title-journal-queries";

interface IUseRevokeTitleJournal {
  titleId: string;
}

export function useRevokeTitleJournal({ titleId }: IUseRevokeTitleJournal) {
  const queryClient = useQueryClient();
  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/cancel",
  );

  return {
    ...mutation,
    mutate: (
      {
        comment,
        skipInvalidate,
      }: {
        comment: string;
        skipInvalidate?: boolean;
      },
      mutateOptions?: TitleJournalMutateOptions,
    ) => {
      mutation.mutate(
        {
          params: {
            path: { titleId },
          },
          body: {
            comment,
          },
        },
        withTitleJournalInvalidation(queryClient, titleId, {
          ...mutateOptions,
          skipInvalidate: skipInvalidate ?? mutateOptions?.skipInvalidate,
        }),
      );
    },
  };
}
